var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-tail",
    style: {
      background: "none",
      borderRadius: "50%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tail-e6f9c25d73633",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    result: "cutoff"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 60,
    intercept: -40
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "ng-attr-filter": "url(#{{config.filterid}})",
    filter: "url(#tail-e6f9c25d73633)",
    transform: "rotate(266.459 50 50)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: "7.5s",
    begin: "0s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.819 50.0066 50.0066)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 19,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.13333333333333333 0 0.03333333333333333 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.804 50.0085 50.0084)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.16666666666666669 0 0.06666666666666667 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.787 50.0093 50.0093)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 17,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.2 0 0.1 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.768 50.0084 50.0083)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 16,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.23333333333333334 0 0.13333333333333333 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.747 49.9979 49.998)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 15,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.26666666666666666 0 0.16666666666666666 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.723 49.9986 49.9986)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 14,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.30000000000000004 0 0.2 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.696 49.9974 49.9975)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 13,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.33333333333333337 0 0.23333333333333334 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.664 50.001 50.001)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 12,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.3666666666666667 0 0.26666666666666666 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.628 49.9975 49.9975)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 11,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.4 0 0.3 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.587 50.0013 50.0013)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 10,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.43333333333333335 0 0.3333333333333333 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.538 50.0004 50.0004)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 9,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.4666666666666667 0 0.36666666666666664 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.481 50.0003 50.0003)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 8,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.5 0 0.4 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.412 50.0001 50.0001)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.5333333333333333 0 0.43333333333333335 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.331 50.0022 50.0022)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.5666666666666667 0 0.4666666666666667 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.232 50.0007 50.0007)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.6 0 0.5 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(359.11 50.0002 50.0002)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.6333333333333333 0 0.5333333333333333 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(358.959 50.0018 50.0018)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.6666666666666666 0 0.5666666666666667 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(358.767 50.0002 50.0002)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.7 0 0.6 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(358.372 49.9996 49.9996)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 1,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.7333333333333333 0 0.6333333333333333 1",
    repeatCount: "indefinite",
    dur: 1.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(358.372 49.9996 49.9996)"
  }, /*#__PURE__*/React.createElement("g", {
    "ng-attr-transform": "translate(50 {{config.cy}})",
    transform: "translate(50 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 0,
    "ng-attr-fill": "{{config.fill}}",
    "ng-attr-transform": "scale({{config.scale}})",
    fill: "#FFFFFF",
    transform: "scale(0.30000000000000004)"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    type: "rotate",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    "ng-attr-dur": "{{config.speed2}}",
    keySplines: "0.7666666666666666 0 0.6666666666666666 1",
    repeatCount: "indefinite",
    dur: 1.875
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.af0b7ff51b16be266e9b59544e28bd0d.svg";
export { ForwardRef as ReactComponent };